import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=3a656570&"
import script from "./Traceability.vue?vue&type=script&lang=js&"
export * from "./Traceability.vue?vue&type=script&lang=js&"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=3a656570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports